<template>
    <tr :key="item.PersonnelID">
        <td>{{item.EmployeeCode}}</td>
        <td>{{item.LastName}}, {{item.FirstName}}</td>
        <td>{{getPlantByID(item.PrimaryPlantID).PlantName}}</td>
        <td>{{getTeamByPlantAndID(item.PrimaryPlantID, item.DefaultTeamId).Name}}</td>
        <td>{{getLevelByID(item.DefaultRoleId).NameWithWorkType}}</td>
        <td>
            <v-autocomplete
                :items="getPlantsWithTeamsSortedArrayExcludingCurrent"
                item-text="PlantName"
                item-value="PlantID"
                v-model="newData.newPlantID"
                hint="New Plant"
                placeholder="New Plant"
                clearable
                :disabled="loadingPlants"
            ></v-autocomplete>
        </td>
        <td>
            <v-autocomplete
                :items="getTeamsForPlantExcludingCurrent"
                item-text="NameWithWorkType"
                item-value="TeamID"
                v-model="newData.newTeamID"
                hint="New Team"
                placeholder="New Team"
                clearable
                :disabled="!oldOrNewPlantID"
                :error="!isValid"
            ></v-autocomplete>
        </td>
        <td>
            <v-autocomplete
                :items="getLevelsForPlantExcludingCurrent"
                item-text="NameWithWorkType"
                item-value="RoleTypeID"
                v-model="newData.newLevelID"
                hint="New Level"
                placeholder="New Level"
                clearable
                :disabled="loadingLevels || !oldOrNewPlantID"
                :error="!isValid"
            ></v-autocomplete>
        </td>
    </tr>
</template>

<script>
import { mapState } from 'vuex';
import { mapGetters } from 'vuex'
 
export default {
    props: ["item"],
    data() {
        return {
            newData: {
                newPlantID: null,
                newTeamID: null,
                newLevelID: null
            }
        }
    },
    components: {
        
    },
    created() {
        
    },
    computed: {
        ...mapState("PersonnelMovementsStore", {
            loadingPlants: state => state.loadingPlants,
            loadingLevels: state => state.loadingLevels,
            levels: state => state.levels
        }),
        ...mapGetters({
            getPlantByID: "PersonnelMovementsStore/getPlantByID",
            getTeamByPlantAndID: "PersonnelMovementsStore/getTeamByPlantAndID",
            getLevelByID: "PersonnelMovementsStore/getLevelByID",
            getPlantsWithTeamsSortedArray: "PersonnelMovementsStore/getPlantsWithTeamsSortedArray",
            getTeamsForPlant: "PersonnelMovementsStore/getTeamsForPlant",
            getLevelsForPlant: "PersonnelMovementsStore/getLevelsForPlant"
        }),
        levelsExcludingCurrent() {
            return this.levels.filter(l => l.RoleTypeID !== this.item.DefaultRoleId);
        },
        getPlantsWithTeamsSortedArrayExcludingCurrent() {
            return this.getPlantsWithTeamsSortedArray.filter(p => p.PlantID !== this.item.PrimaryPlantID);
        },
        oldOrNewPlantID() {
            if (this.newData.newPlantID) {
                return this.newData.newPlantID;
            }

            return this.item.PrimaryPlantID;
        },
        oldOrNewTeamID() {
            if (this.newData.newTeamID) {
                return this.newData.newTeamID;
            }

            return this.item.DefaultTeamId;
        },
        oldOrNewLevelID() {
            if (this.newData.newLevelID) {
                return this.newData.newLevelID;
            }

            return this.item.DefaultRoleId;
        },
        getTeamsForPlantExcludingCurrent() {
            return this.getTeamsForPlant(this.oldOrNewPlantID).filter(t => t.TeamID !== this.item.DefaultTeamId);
        },
        getLevelsForPlantExcludingCurrent() {
            return this.getLevelsForPlant(this.oldOrNewPlantID).filter(t=> t.RoleTypeID !== this.item.DefaultRoleId);
        },
        isValid() {
            if (this.newData.newTeamID > 0 || this.newData.newLevelID > 0) {
                // Validate Team Work Types and Role Work Types match
                let team = this.getTeamByPlantAndID(this.oldOrNewPlantID, this.oldOrNewTeamID);
                let level = this.getLevelByID(this.oldOrNewLevelID);

                return team.WorkTypeID == level.WorkTypeID;
            }

            return true;
        }
    },
    methods: {
        
    },
    watch: {
        newData: {
            handler() {
                let payload = {
                    id: parseInt(this.item.PersonnelID),
                    newData: this.newData
                }

                this.$store.commit("PersonnelMovementsStore/setIndividualUpdate", payload);
            },
            deep: true
        }
    }
}
</script>

<style>
    
</style>
